// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"nB","cardInnerHeading":"nC","editButton":"nD","formClass":"nE","inputClass":"nF","pw":"nG","enterCurrentPw":"nH","cancelButton":"nI","submitButton":"nJ"};